import { Cancel } from 'iconoir-react'
import Button from '../Button'
import InputField from '../InputField'

const PasswordResetModal = ({onCancel, credentials, onInputChange, onSubmit}) => {
  return (
    <form onSubmit={onSubmit} className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>Password Reset</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <p className='text-gray-500 font-medium text-sm'>
            Enter old password
          </p>
          <InputField 
            type={'password'}
            name="old_password"
            isRequired={true}
            onChange={onInputChange}
            value={credentials.old_password}
          />
          <p className='text-gray-500 mt-3 font-medium text-sm'>
            Enter new password
          </p>
          <InputField 
            type={'password'}
            name="new_password"
            isRequired={true}
            onChange={onInputChange}
            value={credentials.new_password}
          />
          <p className='text-gray-500 mt-3 font-medium text-sm'>
            Confirm new password
          </p>
          <InputField 
            type={'password'}
            name="confirm_password"
            isRequired={true}
            onChange={onInputChange}
            value={credentials.confirm_password}
          />
          <br />
          <br />
          <Button
            type="submit"
            label={'Submit'}
            width="w-full"
            bgColor={'wayrideBgColor'}
          />
        </div>
      </div>
    </form>
  )
}

export default PasswordResetModal